module.exports = __webpack_public_path__ + "static/media/twitterIcon.ad9d434d.svg";